// Keep each word together, including hyphenated names, while allowing the
// heading to flow onto multiple lines at the spaces between words.
export function HeroHeadingText({ title }: { title: string }) {
	return Array.from(title.matchAll(/\S+|\s+/g), (match) =>
		/\s/.test(match[0]) ? (
			match[0]
		) : (
			<span key={match.index} style={{ whiteSpace: "nowrap" }}>
				{match[0]}
			</span>
		),
	);
}
